import React from "react";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  tag: string;
  header: string;
};

const SectionHeader: React.FC<Props> = ({tag, header, ...props}) => (
  <div {...props}>
    <span className="ttu font-im fs13" style={{letterSpacing: 3}}>
      {tag}
    </span>
    <h2 className="mt3 fs48 maxw25">{header}</h2>
  </div>
);

export default SectionHeader;
